var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "footer",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", [
        _c("a", { on: { click: _vm.cgv_buttonClick } }, [_vm._v("C.G.V.")]),
        _vm._v(" \n            - "),
        _c("a", { attrs: { href: "/#concept" } }, [_vm._v("Concept")]),
        _vm._v(" \n            - "),
        _c("a", { attrs: { href: "/nos-scenarios-escape-caen" } }, [
          _vm._v("Nos énigmes"),
        ]),
        _vm._v(" \n            - "),
        _c("a", { attrs: { href: "/#nestor-bomb-simulator" } }, [
          _vm._v("NESTOR - Bomb Simulator"),
        ]),
        _vm._v(" \n            - "),
        _c("a", { attrs: { href: "/#infos-pratiques" } }, [
          _vm._v("Infos pratiques"),
        ]),
        _vm._v(" \n            - "),
        _c("a", { attrs: { href: "/entreprises" } }, [_vm._v("Entreprises")]),
        _vm._v(" \n            - "),
        _c(
          "a",
          { attrs: { href: "/nos-scenarios-escape-caen#bons-cadeaux" } },
          [_vm._v("Bons cadeaux")]
        ),
        _vm._v(" \n            - "),
        _c("a", { attrs: { href: "/contact#faq" } }, [_vm._v("F.A.Q.")]),
        _vm._v(" \n            - "),
        _c("a", { attrs: { href: "/contact" } }, [_vm._v("Contact")]),
        _vm._v(" \n            - "),
        _c("a", { attrs: { href: "/#tarifs" } }, [_vm._v("Tarifs")]),
        _vm._v(" \n            - "),
        _c("a", { attrs: { href: "/nos-scenarios-escape-caen" } }, [
          _vm._v("Réserver"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { domProps: { innerHTML: _vm._s(_vm.seo_contentH1) } }),
      _vm._v(" "),
      _c("div", { domProps: { innerHTML: _vm._s(_vm.seo_contentH2) } }),
      _vm._v(" "),
      _c("CGV", { ref: "cgvPopin" }),
      _vm._v(" "),
      _c("Covid19", { ref: "covid19Popin" }),
      _vm._v(" "),
      _c("Pass_Sanitaire", { ref: "passSanitairePopin" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", [
        _c("span", [_vm._v("S.A.R.L. LOCK QUEST®")]),
        _vm._v(
          " - ESCAPE GAME - ESCAPE GAME MOBILE - NESTOR BOMB SIMULATOR - JEUX DE PISTE EN PLEIN AIR\n\t\t        "
        ),
        _c("br"),
        _vm._v(
          "6, chemin de Lamballard 14760 Bretteville-sur-Odon\n            "
        ),
        _c("br"),
        _vm._v("SIRET - 853 196 822 00011\n            "),
        _c("br"),
        _vm._v("Site web réalisé par "),
        _c("a", { attrs: { href: "mailto:newfatioueg@hotmail.com" } }, [
          _vm._v("Vincent GOUEY"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }